<template>
  <main role="main" class="col-md-9 ml-sm-auto col-lg-10 px-md-4 mb-5 bg-white">
    <router-view> </router-view>
  </main>
</template>
<script>
export default {};
</script>
